"use client";

// Корень консоли: список живёт по адресу с именем ресурса.
import { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function DevIndexPage() {
  const router = useRouter();
  useEffect(() => {
    router.replace("/dev/apps");
  }, [router]);
  return null;
}
